module.exports = {"210726001":"黑山街道","210726002":"大虎山街道","210726101":"芳山镇","210726102":"白厂门镇","210726103":"常兴镇","210726104":"姜屯镇","210726105":"励家镇","210726106":"绕阳河镇","210726107":"半拉门镇","210726108":"无梁殿镇","210726109":"胡家镇","210726110":"新立屯镇","210726111":"八道壕镇","210726113":"四家子镇","210726114":"新兴镇","210726116":"太和镇","210726117":"镇安镇","210726201":"英城子乡","210726209":"段家乡","210726210":"大兴乡","210726212":"薛屯乡","210726400":"辽宁省锦州市小东种畜场"}


//////////////////
// WEBPACK FOOTER
// ./src/town/210726.json
// module id = 554
// module chunks = 0